import {
  Box,
  Button,
  Card,
  Flex,
  Group,
  rem,
  Stack,
  Text,
} from "@mantine/core";
import ApprovalInfoCard from "modules/term-deposit/components/ApprovalInfoCard";
import { useTranslation } from "react-i18next";
import { toCurrency } from "utils/common";
import { v4 as uuidv4 } from "uuid"; // Import uuid

const InfoItem = ({
  label,
  value,
  bold = false,
}: {
  label: string;
  value: string;
  bold?: boolean;
}) => (
  <Group align="center" spacing={8}>
    <Text fw={400} color="#6D6D6D" fz={16} miw={160}>
      {label}
    </Text>
    <Text fw={bold ? 700 : 400} fz={14}>
      {value}
    </Text>
  </Group>
);

export const LoanSettlementDetail = ({
  onNext,
  onCancel,
}: {
  onNext: () => void;
  onCancel: () => void;
}) => {
  const { t } = useTranslation();
  const data1 = [
    { label: t("TRANSACTION_TYPE"), value: t("SETTLEMENT"), bold: true },
    { label: t("LOAN_ACCOUNT"), value: "DF330035253231" },
    { label: t("LOAN_ACCOUNT"), value: "029847571234" },
  ];
  const data2 = [
    {
      label: t("OUTSTANDING_PRINCIPAL"),
      value: `${toCurrency(100000000)} VND`,
    },
    {
      label: t("ACCRUED_INTEREST"),
      value: `${toCurrency(12000)} VND`,
    },
    {
      label: t("OVERDUE_PRINCIPAL"),
      value: `${toCurrency(0)} VND`,
    },
    {
      label: t("LATE_PAYMENT_INTEREST"),
      value: `${toCurrency(0)} VND`,
    },
    {
      label: t("LATE_PAYMENT_FEE"),
      value: `${toCurrency(0)} VND`,
    },
    {
      label: t("EARLY_REPAYMENT_FEE"),
      value: `${toCurrency(0)} VND`,
    },
    {
      label: t("TOTAL_SETTLEMENT_AMOUNT"),
      value: `${toCurrency(100012000)} VND`,
      blue: true,
    },
  ];
  return (
    <Box>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          borderLeft: "3px solid #246CF9",
          paddingLeft: "10px",
          margin: "20px 0",
        }}
      >
        <Text fw={600} size="24px">
          {t("TRANSACTION_INFORMATION_CONFIRMATION")}
        </Text>
      </Box>
      <Flex align="start" justify="space-between" gap={24}>
        <Card
          shadow="sm"
          radius="md"
          // w={929}
          // h={800}
          sx={{
            flex: "1",
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <Stack spacing={24}>
            <Text fw={600} fz={20}>
              {t("REQUEST_INFORMATION")}
            </Text>

            {data1.map((item, index) => (
              <InfoItem key={uuidv4()} {...item} />
            ))}

            <Text fw={600} fz={20}>
              {t("REQUEST_INFORMATION")}
            </Text>

            {data2.map((item, index) => (
              <InfoItem key={uuidv4()} {...item} />
            ))}
          </Stack>
        </Card>
        <Box>
          <ApprovalInfoCard />
        </Box>
      </Flex>

      {/* Footer luôn ở cuối */}
      <Group position="center" mt={rem(20)}>
        <Box
          style={{
            position: "fixed",
            bottom: 0,
            right: 0,
            width: "calc(100% - var(--mantine-navbar-width, 0px))",
            padding: "10px 16px",
            display: "flex",
            justifyContent: "right",
            gap: "10px",
            boxShadow: "0px 5px 15px 0px #00000026",
            height: "76px",
            alignItems: "center",
            backgroundColor: "white",
            zIndex: 1,
          }}
        >
          <Button
            sx={() => ({
              width: "160px",
              background: "#F4F4F6",
              borderRadius: "8px",
              padding: "8px 10px",
              cursor: "pointer",
              fontWeight: 600,
              color: "black",
              ":hover": {
                background: "#F4F4F6",
                color: "black",
              },
            })}
            mr="xs"
            type="reset"
            onClick={onCancel}
          >
            {t("CANCEL")}
          </Button>
          <Button
            sx={() => ({
              width: "160px",
              color: "white",
              borderRadius: "8px",
              padding: "8px 10px",
              cursor: "pointer",
              fontWeight: 400,
              ":hover": {
                color: "white",
              },
              background: "#2A81D0",
            })}
            type="submit"
            onClick={onNext}
          >
            {t("NEXT")}
          </Button>
        </Box>
      </Group>
    </Box>
  );
};
